import type { IconNode } from '../types';

/**
 * @name crab
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNy41IDE0QTYgNiAwIDEgMSAxMCAyLjM2TDggNWwyIDJTNyA4IDIgOCIgLz4KICA8cGF0aCBkPSJNMTYuNSAxNEE2IDYgMCAxIDAgMTQgMi4zNkwxNiA1bC0yIDJzMyAxIDggMSIgLz4KICA8cGF0aCBkPSJNMTAgMTN2LTIiIC8+CiAgPHBhdGggZD0iTTE0IDEzdi0yIiAvPgogIDxlbGxpcHNlIGN4PSIxMiIgY3k9IjE3LjUiIHJ4PSI3IiByeT0iNC41IiAvPgogIDxwYXRoIGQ9Ik0yIDE2YzIgMCAzIDEgMyAxIiAvPgogIDxwYXRoIGQ9Ik0yIDIyYzAtMS43IDEuMy0zIDMtMyIgLz4KICA8cGF0aCBkPSJNMTkgMTdzMS0xIDMtMSIgLz4KICA8cGF0aCBkPSJNMTkgMTljMS43IDAgMyAxLjMgMyAzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/crab
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const crab: IconNode = [
  ['path', { d: 'M7.5 14A6 6 0 1 1 10 2.36L8 5l2 2S7 8 2 8', key: 'd2jr0s' }],
  ['path', { d: 'M16.5 14A6 6 0 1 0 14 2.36L16 5l-2 2s3 1 8 1', key: '1ohm1v' }],
  ['path', { d: 'M10 13v-2', key: '1s0weu' }],
  ['path', { d: 'M14 13v-2', key: '1tj297' }],
  ['ellipse', { cx: '12', cy: '17.5', rx: '7', ry: '4.5', key: '1d0wnt' }],
  ['path', { d: 'M2 16c2 0 3 1 3 1', key: 'nzuk83' }],
  ['path', { d: 'M2 22c0-1.7 1.3-3 3-3', key: '16s2xg' }],
  ['path', { d: 'M19 17s1-1 3-1', key: '4rphm0' }],
  ['path', { d: 'M19 19c1.7 0 3 1.3 3 3', key: '1s6n3f' }],
];

export default crab;
